import {v4 as uuidv4} from "uuid";
/* eslint-disable no-template-curly-in-string */
import {faker}  from "@faker-js/faker";
import { getOrgApp } from "../helpers/get-orgApp";
import moment from "moment";
import { formatDateToUTC } from "../../utils/convert-date";
import {
  TERRAFORM_TASK_INPUT_PARAMETERS,
  TERRAFORM_TASK_OUTPUT_PARAMETERS,
} from "../mockData/tasks";
import { TERRAFORM_ENV_ID } from "../scenarios/edu-scenarios";
import { TERRAFORM_COMPLETED_BP_ID } from "./blueprints";

const blueprintNames = [
  "Deploy an ECS cluster",
  "Deploy a Fargate Cluster",
  "Install CloudWatch Agent",
  "Deploy an EMR Cluster",
];
export const blueprintId = () => {
  return { BlueprintId: "7a8e592d-5e37-47ac-877d-c44a817dafc4" };
};

export const appParameters = () => {
  return {
    RegionCode: "us-east-2",
    ApplicationId: "543d4e16-4245-472c-a370-af060194215d",
    DepartmentId: "5bba91b7-551f-4d35-a113-b37fcd840a71",
    EnvironmentId: "1c53f18d-ab61-4378-8362-b80e2aeda768",
    AccountNumber: "568753834354",
    Status: "DELETE_COMPLETE",
    StackName: "Elastic-Search-Setup--2019-09-11--12-37-00",
    CreatedOn: "2019-09-13 14:27:07",
    LaunchRole: "arn:aws:iam::568753834354:role/ELSCloudformationRole",
    Output: [
      {
        OutputKey: "Role",
        OutputValue: `MontyCloud-${uuidv4()}-EC2Role`,
      },
      {
        OutputKey: "InstanceId",
        OutputValue: "i-09c614b73ee811111",
      },
      {
        OutputKey: "InstancePrivateIp",
        OutputValue: faker.internet.ip(),
      },
    ],
    Parameters: [
      {
        ParameterKey: "Application",
        ParameterValue: "App_21",
      },
      {
        ParameterKey: "Environment",
        ParameterValue: "dev",
      },
      {
        ParameterKey: "InstanceName",
        ParameterValue: "EC2 Instance",
      },
      {
        ParameterKey: "OperatingSystem",
        ParameterValue: "AmazonLinux2",
      },
      {
        ParameterKey: "VPC",
        ParameterValue: "vpc-4f5b6327",
      },
      {
        ParameterKey: "Subnet",
        ParameterValue: "subnet-1218e52c",
      },
      {
        ParameterKey: "ESDataInstanceVolumeSize",
        ParameterValue: "20",
      },
      {
        ParameterKey: "ESDataInstanceVolumeType",
        ParameterValue: "gp2",
      },
      {
        ParameterKey: "EBSOptimized",
        ParameterValue: "false",
      },
      {
        ParameterKey: "BlockDeviceDeleteOnTermination",
        ParameterValue: "true",
      },
      {
        ParameterKey: "SecurityGroup",
        ParameterValue: "sg-0008bef9e622b9c17",
      },
      {
        ParameterKey: "InstanceType",
        ParameterValue: "t2.medium",
      },
      {
        ParameterKey: "EC2KeyPair",
        ParameterValue: "",
      },
      {
        ParameterKey: "PolicyName",
        ParameterValue: "",
      },
    ],
    BlueprintId: "7a8e592d-5e37-47ac-877d-c44a817dafc4",
  };
};
export const ecsClusterTemplate = () => {
  return {
    ParentTemplateContent: JSON.stringify(template),
  };
};

export const ecsClusterManifest = () => {
  return {
    ManifestTemplateContent: manifestTemplate,
  };
};

export const appendedRoleText = () => {
  return [
    {
      Action: "s3:GetObject",
      Effect: "Allow",
      Resources:
        "arn:aws:s3:::mc-dev1-assets/73d468c8-99b2-11e9-9487-1243dd31b952/*",
      Sid: "MontyCloudBucketPermission",
    },
    {
      Action: "sns:Publish",
      Effect: "Allow",
      Resources:
        "arn:aws:sns:*:{AccountId}:MontyCloud-Automation-Task-Notification-Topic",
      Sid: "MontyCloudSNSPermission",
    },
  ];
};

export const getParameterGroups = () => {
  return {
    parameterGroups: manifestTemplate.parameters.parameterGroups,
    ManifestTemplateContent: manifestTemplate,
  };
};

export const getStacksData = async (type) => {
  let stacks = [];
  let counter = 5;
  let status = ["Create Completed"];
  if (type === "all") {
    counter = 15;
  }
  for (var i = 0; i < counter; i++) {
    let date = faker.date.between("2019-08-01", "2019-09-15");
    let orgAppDetails = await getOrgApp();
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
    let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
    var stack = {
      AccountNumber: "904433914959",
      RegionCode: "us-east-1",
      Status: faker.helpers.arrayElement(status),
      StackName:
        "ECS-Cluster" +
        "-" +
        moment(date).format("YYYY-MM-DD") +
        "-" +
        moment().format("HH-mm-ss"),
      CreatedOn: formatDateToUTC(date),
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      OrganizationId: selectedOrg.orgId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      DepartmentId: selectedDept.deptId,
      Cost: faker.number.int(45, 55),
    };
    if (type === "all") {
      stack.BlueprintName = faker.helpers.arrayElement(blueprintNames);
    }
    stacks.push(stack);
  }

  return stacks;
};

export const getBundledActions = () => {
  return [
    {
      actionId: "61fc452e-eaf0-4212-b8d1-be4194a03519",
      name: "addNode",
      label: "Add Node",
      description: "This action adds a node to the already launched ES stack",
      type: "CloudFormationUpdate",
      enabled: true,
      owner: "MontyCloud",
      Metadata: {
        Label: "Add Node",
      },
      script: {
        Parameters: {
          DataNodeCount: {
            Description:
              "Enter the additional number of worker Nodes for the ElasticSearch Cluster.",
            Default: 1,
            MinValue: 0,
            MaxValue: 10,
          },
        },
      },
    },
    {
      actionId: "1f19e6d9-c259-458e-9c5e-0335b82e1ac3",
      name: "backup",
      label: "Backup",
      description:
        "This action calls the runcommand to create elastic search backup",
      type: "RunCommand",
      enabled: true,
      owner: "MontyCloud",
      Metadata: {
        Label: "Backup",
      },
      script: {
        Parameters: {
          EsSnapshotBucket: {
            Description: "Name of S3 bucket where snapshot will be saved.",
          },
          EsSnapshotRegion: {
            Description: "Region in which the snapshot will be saved",
          },
          S3RepoName: {
            Description:
              "Name of repository which will be created to store the snapshot",
          },
          SnapshotName: {
            Description: "Name of the snapshot which will be used for restore",
          },
        },
      },
    },
    {
      actionId: "0ca4e673-bca1-4b03-9aaa-ad1bb9945fb0",
      name: "restoreBackup",
      label: "Restore Backup",
      description:
        "This action calls the runcommand to restore elastic search backup",
      type: "RunCommand",
      enabled: true,
      owner: "MontyCloud",
      Metadata: {
        Label: "Restore Backup",
      },
      script: {
        Parameters: {
          S3RepoName: {
            Description:
              "Name of the repository where the snapshots are backed up",
          },
          SnapshotName: {
            Description: "Name of the snapshot to be restored",
          },
        },
      },
    },
    {
      actionId: "04f46176-fa76-43fc-ba61-7b9f7f21795a",
      name: "configureAlerts",
      label: "Configure Alerts",
      description:
        "This actions will be used to create a alarm for the elastic search",
      type: "CloudFormationNew",
      enabled: true,
      owner: "MontyCloud",
      Metadata: {
        Label: "Configure Alerts",
      },
      script: {
        Parameters: {
          SubscriberEmailId: {
            Description: "Email address that will receive cloudwatch alerts",
            Default: "",
          },
          CPUUtilizationThreshold: {
            Description:
              "Threshold value for CPU Utilization, numeric value which will be considered as in %",
            Default: "",
          },
          FreeStorageSpaceThrehold: {
            Description:
              "Threshold value for FreeStorage Space. Value of remaining free storage space in Gib for which alarm needs to be raised.",
            Default: "",
          },
          JVMMemoryPressureThreshold: {
            Description:
              "Threshold value for JVM memory Pressure. Remaining value of Java Heap size for which alarm needs to be raised.",
            Default: "",
          },
          ClusterStateInGreen: {
            Description:
              "Enable it, to send notification when cluster state changes to Green?",
            Default: "yes",
            AllowedValues: ["yes", "no"],
          },
          ClusterStateInRed: {
            Description:
              "Enable it, to send an alarm when cluster state changes to Red?",
            Default: "yes",
            AllowedValues: ["yes", "no"],
          },
          ClusterStateInYellow: {
            Description:
              "Enable it, to send an alarm when cluster state changes to Yellow?",
            Default: "yes",
            AllowedValues: ["yes", "no"],
          },
        },
      },
    },
  ];
};
export const getMetricsData = (data) => {
  let dataPoints = [];
  const metricName = data.metricName || data.MetricName;
  for (let i = 0; i < 35; i++) {
    let date;
    switch (parseInt(data.period)) {
      case 1:
        date = `2020-06-02 04:${faker.number.int(58) + 1}:00+00:00`;
        break;
      case 3:
        date = `2020-06-02 ${faker.number.int(2) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 5:
        date = `2020-06-02 ${faker.number.int(4) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 8:
        date = `2020-06-02 ${faker.number.int(7) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 12:
        date = `2020-06-02 ${faker.number.int(11) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 24:
        date = `2020-06-02 ${faker.number.int(22) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 168:
        date = `2020-06-${faker.number.int(6) + 1} ${faker.number.int(
          24
        )}:${faker.number.int(59)}:00+00:00`;
        break;
      case 336:
        date = `2020-06-${faker.number.int(13) + 1} ${faker.number.int(
          24
        )}:${faker.number.int(59)}:00+00:00`;
        break;
      case 672:
        date = `2020-06-${faker.number.int(27) + 1} ${faker.number.int(
          24
        )}:${faker.number.int(59)}:00+00:00`;
        break;
      default:
        break;
    }
    const num = faker.number.int({ min: 0, max: 10 });
    const item = {
      SampleCount: num,
      Timestamp: date.toLocaleString(),
      Average: num,
      Maximum: num,
      Minimum: num,
      Sum: num,
      Unit: "None",
    };
    dataPoints.push(item);
  }
  return {
    DataPoints: dataPoints,
    MetricName: metricName,
  };
};

const manifestTemplate = {
  kind: "blueprint",
  version: 1.0,
  metadata: {
    name: "AlphaFold Compute Environment",
    description:
      "Launches a bunch of EC2 instances called MasterNode based on the parameter input",
    author: "montycloud",
    version: 1.0,
  },
  prerequisites: [
    "Target VPC for this cluster",
    "Subnets for the instances",
    "Security Group to get associated with instances",
    "Instance KeyName",
  ],
  parameters: {
    parameterGroups: [
      {
        label: "Application Configurations",
        parameters: [
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "Application",
            parameterKey: "Application",
            keyField: "resourceId",
            parameterValue: "",
            defaultValue: "ecs-cluster",
            description: "Name of the Application",
            isMultiSelect: false,
            isOptional: false,
            hideParameter: true,
          },
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "Environment",
            parameterKey: "Environment",
            defaultValue: "Dev",
            keyField: "resourceId",
            parameterValue: "",
            description: "The type of Env. For Ex- PROD, TEST, STG, NON-PROD",
            isMultiSelect: false,
            isOptional: false,
            hideParameter: true,
          },
        ],
      },
      {
        label: "Instance Configurations",
        parameters: [
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "Instance Name",
            parameterKey: "InstanceName",
            keyField: "resourceId",
            defaultValue: "els-app-instance",
            parameterValue: "",
            description: "Mention the name for your EC2 Instance",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "Operating System",
            parameterKey: "OperatingSystem",
            keyField: "resourceId",
            parameterValue: "",
            defaultValue: "AmazonLinux2",
            description: "Choose an Amazon Machine Image",
            allowedValues: [
              "AmazonLinuxHVM",
              "AmazonLinux2",
              "UbuntuServerHVM",
              "RedHatEnterpriseLinux8",
              "SUSELinuxEnterpriseServer15",
            ],
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "VPC",
            initialTemplateType: "VPC",
            parameterLabel: "VPC ID",
            parameterKey: "VPC",
            keyField: "resourceId",
            parameterValue: "",
            description: "The ID of your existing VPC (e.g., vpc-0343606e)",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "Subnet",
            initialTemplateType: "Subnet",
            parameterLabel: "Subnet for server",
            parameterKey: "Subnet",
            keyField: "resourceId",
            parameterValue: "",
            description: "Choose the Subnet to Deploy Instances.",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "EC2 Volume Size",
            parameterKey: "EC2VolumeSize",
            keyField: "resourceId",
            parameterValue: "",
            defaultValue: "30",
            description: "Size of EC2 volume. Minimum 8 GiB",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "EC2 Volume Type",
            parameterKey: "EC2VolumeType",
            keyField: "resourceId",
            parameterValue: "",
            defaultValue: "gp2",
            description:
              "Choose General Purpose SSD(gp2), Provisioned IOPS SSD (io1), Magnetic (standard)",
            allowedValues: ["gp2", "io1", "standard"],
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "EBS Optimized",
            parameterKey: "EBSOptimized",
            keyField: "resourceId",
            parameterValue: "",
            defaultValue: "false",
            description:
              "Choose whether the instance is optimized for Amazon EBS I/O. Choose only InstanceType that supports this",
            allowedValues: ["true", "false"],
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "Block Device DeleteOn Termination",
            parameterKey: "BlockDeviceDeleteOnTermination",
            keyField: "resourceId",
            parameterValue: "",
            defaultValue: "true",
            description:
              "When an instance is terminated, Amazon EC2 uses the value of the DeleteOnTermination attribute for each attached EBS volume to determine whether to preserve or delete the volume when the instance is terminated.",
            allowedValues: ["true", "false"],
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "SecurityGroup",
            initialTemplateType: "SecurityGroup",
            parameterLabel: "Instance Security Group",
            parameterKey: "SecurityGroup",
            keyField: "resourceId",
            parameterValue: "",
            description: "Select an existing security group.",
            isMultiSelect: false,
            isOptional: false,
          },
          {
            parameterType: "List",
            initialTemplateType: "String",
            parameterLabel: "Instance Type",
            parameterKey: "InstanceType",
            keyField: "resourceId",
            parameterValue: "",
            defaultValue: "t2.micro",
            description: "Choose an Instance Type.",
            allowedValues: [
              "t2.nano",
              "t2.micro",
              "t2.small",
              "t2.medium",
              "t2.large",
              "m1.small",
              "m1.medium",
              "m1.large",
              "m1.xlarge",
              "m2.xlarge",
              "m2.2xlarge",
              "m2.4xlarge",
              "m3.medium",
              "m3.large",
              "m3.xlarge",
              "m3.2xlarge",
              "m4.large",
              "m4.xlarge",
              "m4.2xlarge",
              "m4.4xlarge",
              "m4.10xlarge",
              "c1.medium",
              "c1.xlarge",
              "c3.large",
              "c3.xlarge",
              "c3.2xlarge",
              "c3.4xlarge",
              "c3.8xlarge",
              "c4.large",
              "c4.xlarge",
              "c4.2xlarge",
              "c4.4xlarge",
              "c4.8xlarge",
              "g2.2xlarge",
              "g2.8xlarge",
              "r3.large",
              "r3.xlarge",
              "r3.2xlarge",
              "r3.4xlarge",
              "r3.8xlarge",
              "i2.xlarge",
              "i2.2xlarge",
              "i2.4xlarge",
              "i2.8xlarge",
              "d2.xlarge",
              "d2.2xlarge",
              "d2.4xlarge",
              "d2.8xlarge",
              "hs1.8xlarge",
              "cr1.8xlarge",
              "cc2.8xlarge",
            ],
            isMultiSelect: false,
            isOptional: false,
          },
        ],
      },
      {
        label: "Optional Parameters",
        parameters: [
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "EC2 Key Pair",
            parameterKey: "EC2KeyPair",
            keyField: "resourceId",
            parameterValue: "",
            description:
              "Mention KeyPair to Assign to EC2 Instances or leave blank",
            isMultiSelect: false,
            isOptional: true,
          },
          {
            parameterType: "String",
            initialTemplateType: "String",
            parameterLabel: "Policy Name",
            parameterKey: "PolicyName",
            keyField: "resourceId",
            parameterValue: "",
            description: "Enter the Policy Name.Else leave blank",
            isMultiSelect: false,
            isOptional: true,
          },
        ],
      },
    ],
  },
  roleName: "ELSCloudformationRole",

  template: {
    type: "cloudformation",
    permissions: [
      {
        Sid: "EC2Permissions",
        Effect: "Allow",
        Action: [
          "ec2:DescribeKeyPairs",
          "ec2:DescribeVpcAttribute",
          "ec2:ModifyInstanceAttribute",
          "ec2:StartInstances",
          "ec2:DescribeInstances",
          "ec2:RunInstances",
          "ec2:TerminateInstances",
          "ec2:DescribeTags",
          "ec2:CreateTags",
          "ec2:StopInstances",
          "ec2:DisassociateSubnetCidrBlock",
          "ec2:DisassociateIamInstanceProfile",
          "ec2:AssociateSubnetCidrBlock",
          "ec2:DescribeSubnets",
          "ec2:AssociateIamInstanceProfile",
        ],
        Resource: "*",
      },
      {
        Sid: "STSPermissions",
        Effect: "Allow",
        Action: ["sts:AssumeRole"],
        Resource: "*",
      },
      {
        Sid: "CFNPermissions",
        Effect: "Allow",
        Action: [
          "cloudformation:DescribeStackResource",
          "cloudformation:CreateChangeSet",
          "cloudformation:DescribeStackEvents",
          "cloudformation:DescribeChangeSet",
          "cloudformation:ExecuteChangeSet",
          "cloudformation:CreateStack",
          "cloudformation:DeleteStack",
          "cloudformation:ValidateTemplate",
          "cloudformation:DescribeStacks",
        ],
        Resource: "*",
      },
      {
        Sid: "IAMPermissions",
        Effect: "Allow",
        Action: [
          "iam:UpdateLoginProfile",
          "iam:GetRole",
          "iam:PassRole",
          "iam:GetInstanceProfile",
          "iam:CreateInstanceProfile",
          "iam:AddRoleToInstanceProfile",
          "iam:RemoveRoleFromInstanceProfile",
          "iam:DeleteInstanceProfile",
          "iam:TagUser",
        ],
        Resource: "*",
      },
      {
        Sid: "SNSPublishPermission",
        Effect: "Allow",
        Action: ["sns:Publish"],
        Resource: "*",
      },
    ],
  },
  Capabilities: [
    "CAPABILITY_IAM",
    "CAPABILITY_AUTO_EXPAND",
    "CAPABILITY_NAMED_IAM",
  ],
  actions: [
    {
      name: "addNode",
      label: "Add Node",
      description: "This action adds a node to the already launched ES stack",
      type: "CloudFormationUpdate",
      script: {
        Parameters: {
          DataNodeCount: {
            Description:
              "Enter the additional number of worker Nodes for the ElasticSearch Cluster.",
            Default: 1,
            MinValue: 0,
            MaxValue: 10,
          },
        },
      },
    },
    {
      name: "backup",
      label: "Backup",
      description:
        "This action calls the runcommand to create elastic search backup",
      type: "RunCommand",
      script: {
        Parameters: {
          EsSnapshotBucket: {
            Description: "Name of S3 bucket where snapshot will be saved.",
          },
          EsSnapshotRegion: {
            Description: "Region in which the snapshot will be saved",
          },
          S3RepoName: {
            Description:
              "Name of repository which will be created to store the snapshot",
          },
          SnapshotName: {
            Description: "Name of the snapshot which will be used for restore",
          },
        },
      },
    },
    {
      name: "restoreBackup",
      label: "Restore Backup",
      description:
        "This action calls the runcommand to restore elastic search backup",
      type: "RunCommand",
      script: {
        Parameters: {
          S3RepoName: {
            Description:
              "Name of the repository where the snapshots are backed up",
          },
          SnapshotName: {
            Description: "Name of the snapshot to be restored",
          },
        },
      },
    },
    {
      name: "configureAlerts",
      label: "Configure Alerts",
      description:
        "This actions will be used to create a alarm for the elastic search",
      type: "CloudFormationNew",
      script: {
        Parameters: {
          SubscriberEmailId: {
            Description: "Email address that will receive cloudwatch alerts",
            Default: "",
          },
          CPUUtilizationThreshold: {
            Description:
              "Threshold value for CPU Utilization, numeric value which will be considered as in %",
            Default: "",
          },
          FreeStorageSpaceThrehold: {
            Description:
              "Threshold value for FreeStorage Space. Value of remaining free storage space in Gib for which alarm needs to be raised.",
            Default: "",
          },
          JVMMemoryPressureThreshold: {
            Description:
              "Threshold value for JVM memory Pressure. Remaining value of Java Heap size for which alarm needs to be raised.",
            Default: "",
          },
          ClusterStateInGreen: {
            Description:
              "Enable it, to send notification when cluster state changes to Green?",
            Default: "yes",
            AllowedValues: ["yes", "no"],
          },
          ClusterStateInRed: {
            Description:
              "Enable it, to send an alarm when cluster state changes to Red?",
            Default: "yes",
            AllowedValues: ["yes", "no"],
          },
          ClusterStateInYellow: {
            Description:
              "Enable it, to send an alarm when cluster state changes to Yellow?",
            Default: "yes",
            AllowedValues: ["yes", "no"],
          },
        },
      },
    },
  ],
  monitoring: {
    metrics: [
      {
        dimensionName: "InstanceId",
        id: "1591954860891-0",
        metrics: { name: "CPUUtilization", type: "Compute Instance" },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "InstanceId",
        id: "1591954860891-1",
        metrics: { name: "DiskReadOps", type: "Compute Instance" },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "InstanceId",
        id: "1591954860891-2",
        metrics: { name: "EBSReadOps", type: "Compute Instance" },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "InstanceId",
        id: "1591954860891-3",
        metrics: { name: "EBSWriteOps", type: "Compute Instance" },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "InstanceId",
        id: "1591954860891-4",
        metrics: {
          name: "StatusCheckFailed",
          type: "Compute Instance",
        },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "InstanceId",
        id: "1591954860891-5",
        metrics: { name: "DiskWriteOps", type: "Compute Instance" },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "InstanceId",
        id: "1591954860891-6",
        metrics: { name: "NetworkOut", type: "Compute Instance" },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "InstanceId",
        id: "1591954860891-7",
        metrics: { name: "NetworkIn", type: "Compute Instance" },
        namespace: "AWS/EC2",
      },
    ],
    order: [
      "1591954860891-0",
      "1591954860891-1",
      "1591954860891-2",
      "1591954860891-3",
      "1591954860891-4",
      "1591954860891-5",
      "1591954860891-6",
      "1591954860891-7",
    ],
  },
};

const manifestLogOutput = {
  init: `[0m[1mInitializing modules...[0m
    [0m[1mInitializing provider plugins...[0m
    - Reusing previous version of hashicorp/aws from the dependency lock file
    - Using previously-installed hashicorp/aws v4.67.0
    
    [0m[1m[32mTerraform has been successfully initialized![0m[32m[0m
    [0m[32m
    You may now begin working with Terraform. Try running "terraform plan" to see
    any changes that are required for your infrastructure. All Terraform commands
    should now work.
    
    If you ever set or change modules or backend configuration for Terraform,
    rerun this command to reinitialize your working directory. If you forget, other
    commands will detect it and remind you to do so if necessary.[0m"`,
  validate: `\x1b[32m\x1b[1mSuccess!\x1b[0m The configuration is valid.\x1b[0m`,
};

const folderstructure = {
  Name: "ProteinResearch-TF",
  isFolder: true,
  Path: "s3://your_bucket_name/tfsample",
  Children: [
    {
      Name: "ProteinResearch-TF",
      isFolder: true,
      Path: "s3://your_bucket_name/tfsample",
      Children: [
        {
          Name: "ProteinResearch_EC2.tf",
          isFolder: false,
          Path: "s3://your_bucket_name/ProteinResearch_EC2.tf",
        },
        {
          Name: "ProteinResearch_ElasticSearch.tf",
          isFolder: false,
          Path: "s3://your_bucket_name/ProteinResearch_ElasticSearch.tf",
        },
        {
          Name: "ProteinResearch_Lambda.tf",
          isFolder: false,
          Path: "s3://your_bucket_name/ProteinResearch_Lambda.tf",
        },
        {
          Name: "ProteinResearch_RDS.tf",
          isFolder: false,
          Path: "s3://your_bucket_name/ProteinResearch_RDS.tf",
        },
        {
          Name: "ProteinResearch_S3.tf",
          isFolder: false,
          Path: "s3://your_bucket_name/ProteinResearch_S3.tf",
        },
        {
          Name: "provider.tf",
          isFolder: false,
          Path: "s3://your_bucket_name/provider.tf",
        },
        {
          Name: "terraform.tfvars",
          isFolder: false,
          Path: "s3://your_bucket_name/terraform.tfvars",
        },
        {
          Name: "variable.tf",
          isFolder: false,
          Path: "s3://your_bucket_name/variable.tf",
        },
      ],
    },
  ],
};

const parameters = {
  parameterGroups: [
    {
      id: "55",
      label: "Default Configuration",
      parameters: [
        {
          description: "Name of the Application Environment",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "Environment_Name",
          parameterLabel: "Environment Name",
          parameterType: "String",
          parameterValue: "PRD",
        },
      ],
    },
    {
      id: "56",
      label: "ProteinResearch S3 Configuration",
      parameters: [
        {
          description: "Name of the first S3 bucket for protein research data",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_DataBucket_1",
          parameterLabel: "Bucket Name",
          parameterType: "String",
          parameterValue: "prdatabucket1",
        },
        {
          description: "Name of the second S3 bucket for protein research data",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_DataBucket_2",
          parameterLabel: "Bucket Name",
          parameterType: "String",
          parameterValue: "prdatabucket2",
        },
        {
          description: "Name of the third S3 bucket for protein research data",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_DataBucket_3",
          parameterLabel: "Bucket Name",
          parameterType: "String",
          parameterValue: "prdatabucket3",
        },
      ],
    },

    {
      id: "57",
      label: "ProteinResearch EC2 Configuration",
      parameters: [
        {
          description: "SSH public key for EC2 instance",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "public_key",
          parameterLabel: "Public SSH Key",
          parameterType: "String",
          parameterValue: "ssh-rsa AAAAB3NzaC1yc2EAAAADAQABAAAA...",
        },
        {
          description: "Instance type of EC2 instance for protein research",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "instance_type",
          parameterLabel: "Instance Type",
          parameterType: "String",
          parameterValue: "t3.2xlarge",
        },
      ],
    },
    {
      id: "58",
      label: "ProteinResearch ELS Configuration",
      parameters: [
        {
          description: "VPC ID to launch resources in",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "vpc_id",
          parameterLabel: "VPC",
          parameterType: "String",
          parameterValue: "vpc-096420827398e34dc",
        },
        {
          description: "CIDR block range for the VPC",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "cidrblock",
          parameterLabel: "Cidr Block",
          parameterType: "String",
          parameterValue: "0.0.0.0/0",
        },
        {
          description: "Instance type for the Elasticsearch cluster",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "ELS_Cluster_Instance_Type",
          parameterLabel: "ElasticSearch CLuster Instance Type",
          parameterType: "String",
          parameterValue: "t2.small.elasticsearch",
        },
        {
          description: "Number of instances in the Elasticsearch cluster",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "ELS_Cluster_Instance_Count",
          parameterLabel: "ElasticSearch Cluster Instance Count",
          parameterType: "String",
          parameterValue: "1",
        },
        {
          description:
            "Whether to use EBS volumes for the Elasticsearch cluster",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "ELS_EBS",
          parameterLabel: "ElasticSearch Volume Enabled",
          parameterType: "bool",
          parameterValue: "true",
        },
        {
          description:
            "Size of EBS volumes for the Elasticsearch cluster in GB",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "ELS_Volume_Size",
          parameterLabel: "ElasticSearch Volume Size",
          parameterType: "number",
          parameterValue: "20",
        },
        {
          description:
            "The hour in which the daily snapshot is taken for the Elasticsearch cluster",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "ELS_Snapshot_Start_Time",
          parameterLabel: "ElasticSearch Volume Enabled",
          parameterType: "number",
          parameterValue: "23",
        },
        {
          description: "Version of Elasticsearch to use in the cluster",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "ELS_Version",
          parameterLabel: "ElasticSearch Volume Size",
          parameterType: "string",
          parameterValue: "7.1",
        },
        {
          description: "Domain name for the Elasticsearch cluster",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "ELS_Domain_Name",
          parameterLabel: "ElasticSearch Domain Name",
          parameterType: "string",
          parameterValue: "els-proteinresearch-domain",
        },
        {
          description: "S3 bucket for Elasticsearch snapshots",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "ELS_Snapshot_Bucket",
          parameterLabel: "ElasticSearch Volume Size",
          parameterType: "string",
          parameterValue: "elsproteinresearchsnapshotbucket",
        },
      ],
    },
    {
      id: "59",
      label: "ProteinResearch RDS Configuration",
      parameters: [
        {
          description: "Allocated storage size for the RDS instance in GB",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_RDS_Storage",
          parameterLabel: "RDS Database Storage Size",
          parameterType: "number",
          parameterValue: "20",
        },
        {
          description: "Database engine to be used for the RDS instance",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_RDS_Engine",
          parameterLabel: "RDS Database Engine",
          parameterType: "String",
          parameterValue: "mysql",
        },
        {
          description: "Database engine version for the RDS instance",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_RDS_Engine_Version",
          parameterLabel: "RDS Database Engine Version",
          parameterType: "String",
          parameterValue: "5.7",
        },
        {
          description: "Instance class of the RDS instance",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_RDS_Instance_Class",
          parameterLabel: "RDS Database Instance Class",
          parameterType: "String",
          parameterValue: "db.t2.micro",
        },
        {
          description: "Database name for the RDS instance",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_RDS_Name",
          parameterLabel: "RDS Database Name",
          parameterType: "String",
          parameterValue: "ProteinResearch-Enricher-DB",
        },
        {
          description: "Master username for the RDS instance",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_RDS_UserName",
          parameterLabel: "RDS Database User Name",
          parameterType: "String",
          parameterValue: "masteradmin",
        },
        {
          description: "Master password for the RDS instance",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_RDS_Password",
          parameterLabel: "RDS Database Password",
          parameterType: "String",
          parameterValue: "F0X99Pr0teIn",
        },
        {
          description: "Parameter group for the RDS instance",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_RDS_PG",
          parameterLabel: "RDS Database Parameter Group",
          parameterType: "string",
          parameterValue: "default.mysql5.7",
        },
      ],
    },
    {
      id: "60",
      label: "ProteinResearch Lambda Configuration",
      parameters: [
        {
          description: "Runtime environment for the Lambda function",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_LambdaRuntime",
          parameterLabel: "Lambda Runtime",
          parameterType: "String",
          parameterValue: "python3.8",
        },
        {
          description:
            "The architecture for the Lambda function (e.g. x86_64, arm64)",
          existingParameter: true,
          initialTemplateType: "String",
          isMultiSelect: false,
          isOptional: false,
          keyField: "resourceId",
          parameterKey: "PR_LambdaArchitecture",
          parameterLabel: "Lambda Architecture",
          parameterType: "String",
          parameterValue: "x86_64",
        },
      ],
    },
  ],
};

export const terraformManifestDraft = {
  // EC2 BP draft
  ManifestTemplateContent: {
    metadata: {
      name: "EC2 Linux Instance - Terraform",
      description: "This Terraform service catalog creates an EC2 Instance",
      category: "Server Blueprint",
      type: "Terraform",
      departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
      orgs: [],
    },
    parameters: {
      parameterGroups: [
        {
          id: "48",
          label: "Default Configuration",
          parameters: [
            {
              defaultValue: "t2.micro",
              description: "EC2 instance type",
              existingParameter: true,
              initialTemplateType: "String",
              isMultiSelect: false,
              isOptional: false,
              keyField: "resourceId",
              parameterKey: "instance_type",
              parameterLabel: "Instance Type",
              parameterType: "String",
              parameterValue: "t2.large",
            },
            {
              description: "Name tag for the EC2 instance",
              existingParameter: true,
              initialTemplateType: "String",
              isMultiSelect: false,
              isOptional: false,
              keyField: "resourceId",
              parameterKey: "instance_name",
              parameterLabel: "Instance Name",
              parameterType: "String",
              parameterValue: "datafeederec2",
            },
          ],
        },
      ],
    },
    actions: [],
    monitoring: {
      order: [],
      metrics: [],
    },
    folderstructure,
    updateVersion: "1.0",
    roleName: "",
    status: "VALIDATED",
    UploadedStatus: "Draft",
    output: manifestLogOutput,
  },
};

export const terraformCreateManifest = {
  ManifestTemplateContent: {
    metadata: {
      name: "test-terraform2",
      description: "",
      category: "Infrastructure",
      type: "Terraform",
      departments: [],
      orgs: [],
    },
    parameters,
    actions: [],
    monitoring: {
      order: [],
      metrics: [],
    },
    updateVersion: "1.0",
    roleName: "",
    status: "VALIDATED",
    folderstructure,
    output: manifestLogOutput,
  },
};

export const terraformManifestCompleted = {
  // S3 completed BP
  ManifestTemplateContent: {
    metadata: {
      name: "Analytics and Data Insights Accelerator", // s3
      description:
        "Description: Deploy an integrated Data Insights Platform featuring Elasticsearch, EC2, Lambda, S3 buckets, and RDS. Achieve high availability, fault tolerance, auto-scaling with network optimization monitoring and ops automation along with security best practices . Utilize Elasticsearch for analytics, EC2 for processing, Lambda for serverless compute, S3 for storage, and RDS for structured data management.",
      category: "Infrastructure",
      type: "Terraform",
      departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
      orgs: [],
    },
    parameters,
    actions: [],
    monitoring: {
      order: [],
      metrics: [],
    },
    updateVersion: "1.0",
    roleName: "MontyCloud-test-terraform2-Role-v1-dev1",
    status: "VALIDATED",
    UploadedStatus: "COMPLETED",
    folderstructure,
    output: manifestLogOutput,
  },
};

const template = {
  AWSTemplateFormatVersion: "2010-09-09",
  Description:
    "This is master template for deployment of ElasticSearch cluster, which configures Security group, Instance profile, IAM Role and policy. It also creates S3 bucket to store ElasticSearch snapshot. Depending on the user configuration, it deploys Master and Data nodes.",
  Metadata: {
    "AWS::CloudFormation::Interface": {
      ParameterGroups: [
        {
          Label: {
            default: "Application Configuration",
          },
          Parameters: ["Application", "ClusterName", "Environment"],
        },
        {
          Label: {
            default: "Network Configuration",
          },
          Parameters: ["VPC", "Subnets", "ElasticSearchSecurityGroup"],
        },
        {
          Label: {
            default: "Instance Configuration",
          },
          Parameters: [
            "MasterNodeInstanceType",
            "DataNodeInstanceType",
            "AMIId",
            "ESMasterInstanceVolumeSize",
            "ESMasterInstanceVolumeType",
            "ESDataInstanceVolumeSize",
            "ESDataInstanceVolumeType",
            "KeyName",
            "MasterNodeCount",
            "DataNodeCount",
          ],
        },
        {
          Label: {
            default: "ElasticSearch Configuration",
          },
          Parameters: ["ElasticSearchVersion"],
        },
        {
          Label: {
            default: "ElasticSearch Advanced Configuration",
          },
          Parameters: ["FieldDataCacheSize"],
        },
      ],
    },
  },
  Parameters: {
    MasterNodeInstanceType: {
      Type: "String",
      Default: "t2.medium",
      AllowedValues: [
        "t2.medium",
        "t2.large",
        "c5.large",
        "c5.xlarge",
        "r5.large",
        "r5.2xlarge",
      ],
      Description: "Enter the Instance Type. Default is t2.medium.",
    },
    DataNodeInstanceType: {
      Type: "String",
      Default: "t2.medium",
      AllowedValues: [
        "t2.medium",
        "t2.large",
        "c5.large",
        "c5.xlarge",
        "r5.large",
        "r5.2xlarge",
      ],
      Description:
        "Enter the Instance Type for Data Node. Default is t2.medium.",
    },
    AMIId: {
      Type: "AWS::SSM::Parameter::Value<AWS::EC2::Image::Id>",
      Default: "/aws/service/ami-amazon-linux-latest/amzn2-ami-hvm-x86_64-gp2",
      Description: "Enter the AMI ID you want for the ElasticSearch Cluster.",
    },
    ElasticSearchVersion: {
      Type: "String",
      Default: "7.2.0",
      AllowedValues: ["7.2.0", "5.5.3"],
      Description: "Enter the version of ElasticSearch Cluster.",
    },
    ESMasterInstanceVolumeSize: {
      Type: "String",
      Description:
        "Enter size for the EBS volume that you want to attach to the Master EC2 Instance.",
      Default: 20,
    },
    ESMasterInstanceVolumeType: {
      Type: "String",
      Description:
        "Enter type for the EBS volume that you want to attach to the Master EC2 Instance.",
      AllowedValues: ["gp2"],
      Default: "gp2",
    },
    ESDataInstanceVolumeSize: {
      Type: "String",
      Description:
        "Enter size for the EBS volume that you want to attach to the Data EC2 Instance.",
      Default: 20,
    },
    ESDataInstanceVolumeType: {
      Type: "String",
      Description:
        "Enter type for the EBS volume that you want to attach to the Data EC2 Instance.",
      AllowedValues: ["gp2"],
      Default: "gp2",
    },
    Subnets: {
      Type: "List<AWS::EC2::Subnet::Id>",
      Description:
        "Select subnet in which to launch EC2 instances. Select at least 2 subnets for high availability.",
    },
    KeyName: {
      Type: "AWS::EC2::KeyPair::KeyName",
      Description:
        "Enter the Key Pair name to be associated with the EC2 Instances.",
    },
    ElasticSearchSecurityGroup: {
      Type: "List<AWS::EC2::SecurityGroup::Id>",
      Description: "Security Group Id with which instance is configured with",
    },
    Application: {
      Description: "Name of the Application.",
      Type: "String",
      Default: "ELS-LS",
    },
    ClusterName: {
      Type: "String",
      Default: "elasticsearch-test",
      Description:
        "Tag value to describe which cluster this instance belongs to.",
    },
    Environment: {
      Description: "The type of Environment? ex: PROD, TEST, STG, NON-PROD.",
      Type: "String",
      Default: "TEST",
    },
    MasterNodeCount: {
      Type: "String",
      Default: 3,
      AllowedValues: [1, 3, 5],
      Description:
        "Enter the number of Master Node for the ElasticSearch Cluster.",
    },
    DataNodeCount: {
      Type: "Number",
      Default: 3,
      AllowedValues: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      Description:
        "Enter the number of Data Node for the ElasticSearch Cluster.",
    },
    VPC: {
      Type: "AWS::EC2::VPC::Id",
      Description:
        "Enter VPC ID in which you want to launch ElasticSearch Cluster.",
    },
    FieldDataCacheSize: {
      Type: "String",
      Default: "20",
      Description:
        "Enter Indices Field data cache size for Data Nodes. Leave it blank to set it to a default value.",
    },
  },
  Conditions: {
    MasterNodeLaunch1: {
      "Fn::Equals": [1, 1],
    },
    MasterNodeLaunch2: {
      "Fn::Not": [
        {
          "Fn::Equals": [
            1,
            {
              Ref: "MasterNodeCount",
            },
          ],
        },
      ],
    },
  },
  Resources: {
    ElasticSearchInstanceRole: {
      Type: "AWS::IAM::Role",
      Properties: {
        RoleName: {
          "Fn::Sub": "ES_INSTANCE_${Application}_${Environment}_ROLE",
        },
        ManagedPolicyArns: ["arn:aws:iam::aws:policy/AmazonEC2ReadOnlyAccess"],
        AssumeRolePolicyDocument: {
          Version: "2012-10-17",
          Statement: [
            {
              Effect: "Allow",
              Principal: {
                Service: ["ec2.amazonaws.com"],
              },
              Action: ["sts:AssumeRole"],
            },
          ],
        },
        Path: "/",
        Tags: [
          {
            Key: "Environment",
            Value: {
              Ref: "Environment",
            },
          },
          {
            Key: "Application",
            Value: {
              Ref: "Application",
            },
          },
          {
            Key: "Vendor",
            Value: "MontyCloud",
          },
        ],
      },
    },
    ElasticSearchS3BucketPolicies: {
      Type: "AWS::IAM::ManagedPolicy",
      Properties: {
        ManagedPolicyName: {
          "Fn::Sub": "ES_S3Bucket_${Application}_${Environment}_POLICY",
        },
        PolicyDocument: {
          Version: "2012-10-17",
          Statement: [
            {
              Sid: "S3AccessPermissions",
              Effect: "Allow",
              Action: [
                "s3:GetObject",
                "s3:PutObject",
                "s3:ListObjects",
                "s3:ListBucket",
                "s3:AbortMultipartUpload",
                "s3:ListMultipartUploadParts",
                "s3:ListBucketMultipartUploads",
                "s3:DeleteObject",
              ],
              Resource: ["*"],
            },
            {
              Sid: "DescribeInstancesPermissions",
              Effect: "Allow",
              Action: ["ec2:DescribeInstances"],
              Resource: ["*"],
            },
          ],
        },
        Roles: [
          {
            Ref: "ElasticSearchInstanceRole",
          },
        ],
      },
    },
    ELSSSMRolePolicies: {
      Type: "AWS::IAM::ManagedPolicy",
      Properties: {
        ManagedPolicyName: {
          "Fn::Sub": "ES_SSM_${Application}_${Environment}_POLICY",
        },
        PolicyDocument: {
          Version: "2012-10-17",
          Statement: [
            {
              Effect: "Allow",
              Action: [
                "ssm:DescribeAssociation",
                "ssm:GetDeployablePatchSnapshotForInstance",
                "ssm:GetDocument",
                "ssm:GetManifest",
                "ssm:ListAssociations",
                "ssm:ListInstanceAssociations",
                "ssm:PutInventory",
                "ssm:PutComplianceItems",
                "ssm:PutConfigurePackageResult",
                "ssm:UpdateAssociationStatus",
                "ssm:UpdateInstanceAssociationStatus",
                "ssm:UpdateInstanceInformation",
                "ssm:ResumeSession",
                "ssm:DescribeSessions",
                "ssm:TerminateSession",
                "ssm:StartSession",
              ],
              Resource: "*",
            },
            {
              Effect: "Allow",
              Action: [
                "ssm:DescribeParameters",
                "ssm:PutParameter",
                "ssm:GetParameters",
                "ssm:GetParameter",
              ],
              Resource: "*",
            },
            {
              Effect: "Allow",
              Action: [
                "ec2messages:AcknowledgeMessage",
                "ec2messages:FailMessage",
                "ec2messages:GetEndpoint",
                "ec2messages:GetMessages",
                "ec2messages:SendReply",
              ],
              Resource: "*",
            },
            {
              Effect: "Allow",
              Action: ["cloudwatch:PutMetricData"],
              Resource: "*",
            },
            {
              Effect: "Allow",
              Action: [
                "ec2:DescribeInstanceStatus",
                "ec2:CreateTags",
                "ec2:ModifyVolume",
              ],
              Resource: "*",
            },
            {
              Effect: "Allow",
              Action: [
                "logs:CreateLogGroup",
                "logs:CreateLogStream",
                "logs:DescribeLogGroups",
                "logs:DescribeLogStreams",
                "logs:PutLogEvents",
              ],
              Resource: "*",
            },
          ],
        },
        Roles: [
          {
            Ref: "ElasticSearchInstanceRole",
          },
        ],
      },
    },
    ElasticSearchInstanceProfile: {
      Type: "AWS::IAM::InstanceProfile",
      Properties: {
        Path: "/",
        Roles: [
          {
            Ref: "ElasticSearchInstanceRole",
          },
        ],
        InstanceProfileName: {
          "Fn::Sub": "ES_INSTANCE_${Application}_${Environment}_PROFILE",
        },
      },
    },
    ELSBackupRepositoryBucket: {
      Type: "AWS::S3::Bucket",
      DeletionPolicy: "Retain",
      Properties: {
        AccessControl: "LogDeliveryWrite",
        LifecycleConfiguration: {
          Rules: [
            {
              AbortIncompleteMultipartUpload: {
                DaysAfterInitiation: 7,
              },
              ExpirationInDays: 366,
              Id: "delete_old_versions",
              Status: "Enabled",
            },
          ],
        },
        Tags: [
          {
            Key: "Environment",
            Value: {
              Ref: "Environment",
            },
          },
          {
            Key: "Application",
            Value: {
              Ref: "Application",
            },
          },
          {
            Key: "Vendor",
            Value: "MontyCloud",
          },
        ],
      },
    },
    ELSBackupRepositoryBucketPolicy: {
      Type: "AWS::S3::BucketPolicy",
      Properties: {
        Bucket: {
          Ref: "ELSBackupRepositoryBucket",
        },
        PolicyDocument: {
          Version: "2012-10-17",
          Statement: [
            {
              Sid: "AccessOnlyFromInstanceWithRoleId",
              Effect: "Deny",
              Principal: "*",
              Action: ["s3:GetObject*", "s3:PutObject*", "s3:DeleteObject*"],
              Resource: [
                {
                  "Fn::Sub": "arn:aws:s3:::${ELSBackupRepositoryBucket}",
                },
                {
                  "Fn::Sub": "arn:aws:s3:::${ELSBackupRepositoryBucket}/*",
                },
              ],
              Condition: {
                StringNotLike: {
                  "aws:userId": [
                    {
                      "Fn::Join": [
                        "",
                        [
                          {
                            "Fn::GetAtt": [
                              "ElasticSearchInstanceRole",
                              "RoleId",
                            ],
                          },
                          ":",
                          "*",
                        ],
                      ],
                    },
                  ],
                },
              },
            },
          ],
        },
      },
    },
    ElasticLoadBalancerForDataNodes: {
      Type: "AWS::ElasticLoadBalancing::LoadBalancer",
      Properties: {
        CrossZone: "true",
        Subnets: {
          Ref: "Subnets",
        },
        Scheme: "internal",
        Listeners: [
          {
            LoadBalancerPort: "80",
            InstancePort: "9200",
            Protocol: "HTTP",
          },
        ],
        SecurityGroups: {
          Ref: "ElasticSearchSecurityGroup",
        },
        HealthCheck: {
          Target: "HTTP:9200/",
          HealthyThreshold: "2",
          UnhealthyThreshold: "3",
          Interval: "10",
          Timeout: "5",
        },
      },
    },
    ElasticLoadBalancer: {
      Type: "AWS::ElasticLoadBalancing::LoadBalancer",
      Properties: {
        CrossZone: "true",
        Subnets: {
          Ref: "Subnets",
        },
        Listeners: [
          {
            LoadBalancerPort: "80",
            InstancePort: "9200",
            Protocol: "HTTP",
          },
        ],
        SecurityGroups: {
          Ref: "ElasticSearchSecurityGroup",
        },
        HealthCheck: {
          Target: "HTTP:9200/",
          HealthyThreshold: "2",
          UnhealthyThreshold: "5",
          Interval: "10",
          Timeout: "5",
        },
      },
    },
    MasterNodeInstance1: {
      Condition: "MasterNodeLaunch1",
      Type: "AWS::CloudFormation::Stack",
      DependsOn: ["ElasticSearchInstanceProfile"],
      Properties: {
        TemplateURL:
          "https://mc-stg1-blueprints.s3.amazonaws.com/ElasticSearch/elsmasternestedtemplate.json",
        Parameters: {
          KeyName: {
            Ref: "KeyName",
          },
          Subnets: {
            "Fn::Join": [
              ",",
              {
                Ref: "Subnets",
              },
            ],
          },
          IamInstanceProfile: {
            Ref: "ElasticSearchInstanceProfile",
          },
          MasterNodeCount: 1,
          InstanceType: {
            Ref: "MasterNodeInstanceType",
          },
          ElasticLoadBalancer: {
            Ref: "ElasticLoadBalancer",
          },
          AMIId: {
            Ref: "AMIId",
          },
          ESInstanceVolumeSize: {
            Ref: "ESMasterInstanceVolumeSize",
          },
          ESInstanceVolumeType: {
            Ref: "ESMasterInstanceVolumeType",
          },
          InstanceSecurityGroupId: {
            "Fn::Join": [
              ",",
              {
                Ref: "ElasticSearchSecurityGroup",
              },
            ],
          },
          Application: {
            Ref: "Application",
          },
          ClusterName: {
            Ref: "ClusterName",
          },
          ElasticSearchVersion: {
            Ref: "ElasticSearchVersion",
          },
          S3ESScriptBucketName: "mc-stg1-blueprints",
          S3ESScriptBucketFolderName:
            "ElasticSearch/scripts/elasticsearch_scripts",
          S3ESScriptForCWAgntBucketFolderName:
            "ElasticSearch/scripts/cloudwatchagent_scripts",
        },
      },
    },
    MasterNodeInstance2: {
      Condition: "MasterNodeLaunch2",
      DependsOn: ["ElasticSearchInstanceProfile"],
      Type: "AWS::CloudFormation::Stack",
      Properties: {
        TemplateURL:
          "https://mc-stg1-blueprints.s3.amazonaws.com/ElasticSearch/elsmastersnestedtemplate.json",
        Parameters: {
          KeyName: {
            Ref: "KeyName",
          },
          Subnets: {
            "Fn::Join": [
              ",",
              {
                Ref: "Subnets",
              },
            ],
          },
          ElasticLoadBalancer: {
            Ref: "ElasticLoadBalancer",
          },
          IamInstanceProfile: {
            Ref: "ElasticSearchInstanceProfile",
          },
          MasterNodeCount: {
            Ref: "MasterNodeCount",
          },
          InstanceType: {
            Ref: "MasterNodeInstanceType",
          },
          AMIId: {
            Ref: "AMIId",
          },
          ESInstanceVolumeSize: {
            Ref: "ESMasterInstanceVolumeSize",
          },
          ESInstanceVolumeType: {
            Ref: "ESMasterInstanceVolumeType",
          },
          InstanceSecurityGroupId: {
            "Fn::Join": [
              ",",
              {
                Ref: "ElasticSearchSecurityGroup",
              },
            ],
          },
          Application: {
            Ref: "Application",
          },
          ClusterName: {
            Ref: "ClusterName",
          },
          ElasticSearchVersion: {
            Ref: "ElasticSearchVersion",
          },
          S3ESScriptBucketName: "mc-stg1-blueprints",
          S3ESScriptBucketFolderName:
            "ElasticSearch/scripts/elasticsearch_scripts",
          S3ESScriptForCWAgntBucketFolderName:
            "ElasticSearch/scripts/cloudwatchagent_scripts",
        },
      },
    },
    DataNodeInstance1: {
      Type: "AWS::CloudFormation::Stack",
      DependsOn: ["ElasticSearchInstanceProfile"],
      Properties: {
        TemplateURL:
          "https://mc-stg1-blueprints.s3.amazonaws.com/ElasticSearch/elsdatanestedtemplate.json",
        Parameters: {
          InstanceType: {
            Ref: "DataNodeInstanceType",
          },
          KeyName: {
            Ref: "KeyName",
          },
          Subnets: {
            "Fn::Join": [
              ",",
              {
                Ref: "Subnets",
              },
            ],
          },
          IamInstanceProfile: {
            Ref: "ElasticSearchInstanceProfile",
          },
          DataNodeCount: {
            Ref: "DataNodeCount",
          },
          ElasticLoadBalancer: {
            Ref: "ElasticLoadBalancerForDataNodes",
          },
          AMIId: {
            Ref: "AMIId",
          },
          ESInstanceVolumeSize: {
            Ref: "ESDataInstanceVolumeSize",
          },
          ESInstanceVolumeType: {
            Ref: "ESDataInstanceVolumeType",
          },
          InstanceSecurityGroupId: {
            "Fn::Join": [
              ",",
              {
                Ref: "ElasticSearchSecurityGroup",
              },
            ],
          },
          Application: {
            Ref: "Application",
          },
          ClusterName: {
            Ref: "ClusterName",
          },
          ElasticSearchVersion: {
            Ref: "ElasticSearchVersion",
          },
          S3ESScriptBucketName: "mc-stg1-blueprints",
          S3ESScriptBucketFolderName:
            "ElasticSearch/scripts/elasticsearch_scripts",
          S3ESScriptForCWAgntBucketFolderName:
            "ElasticSearch/scripts/cloudwatchagent_scripts",
          FieldDataCacheSize: {
            Ref: "FieldDataCacheSize",
          },
        },
      },
    },
  },
  Outputs: {
    URL: {
      Description: "The URL of the website",
      Value: {
        "Fn::Join": [
          "",
          [
            "http://",
            {
              "Fn::GetAtt": ["ElasticLoadBalancer", "DNSName"],
            },
          ],
        ],
      },
    },
  },
};

export const terraformAppParameters = () => {
  return {
    RegionCode: "us-east-2",
    ApplicationId: TERRAFORM_ENV_ID,
    DepartmentId: "5bba91b7-551f-4d35-a113-b37fcd840a71",
    EnvironmentId: TERRAFORM_ENV_ID,
    AccountNumber: "568753834354",
    Status: "DELETE_COMPLETE",
    StackName: "Elastic-Search-Setup--2019-09-11--12-37-00",
    CreatedOn: "2019-09-13 14:27:07",
    LaunchRole: "arn:aws:iam::568753834354:role/ELSCloudformationRole",
    Output: TERRAFORM_TASK_OUTPUT_PARAMETERS,
    Parameters: TERRAFORM_TASK_INPUT_PARAMETERS,
    BlueprintId: TERRAFORM_COMPLETED_BP_ID,
  };
};
